import { apiClient } from "./client";
import type { ReportsChartsDatasetResponse, ReportsDatasetResponse, SalesAnalyticsResponse } from "./types";

export interface SalesAnalyticsQueryParams {
    channel?: string;
    region?: string;
    store?: string;
    dateFrom?: string;
    dateTo?: string;
    client?: string;
    product?: string;
    status?: string;
    sections?: "core" | "all";
}

export interface SalesAnalyticsSupplementsResponse {
    breakdowns: Pick<SalesAnalyticsResponse["breakdowns"], "byArticle" | "byCategory" | "bySupplier">;
    stores: SalesAnalyticsResponse["stores"];
}

export async function fetchSalesAnalytics(period?: string, filters?: SalesAnalyticsQueryParams) {
    const response = await apiClient.get<SalesAnalyticsResponse>("/reports/sales-analytics", {
        params: {
            ...(period && period !== "Персонализиран" ? { period } : {}),
            ...(filters?.dateFrom ? { date_from: filters.dateFrom } : {}),
            ...(filters?.dateTo ? { date_to: filters.dateTo } : {}),
            ...(filters?.channel && filters.channel !== "Всички" ? { channel: filters.channel } : {}),
            ...(filters?.region && filters.region !== "Всички" ? { region: filters.region } : {}),
            ...(filters?.store && filters.store !== "Всички" ? { store: filters.store } : {}),
            ...(filters?.client?.trim() ? { client: filters.client.trim() } : {}),
            ...(filters?.product?.trim() ? { product: filters.product.trim() } : {}),
            ...(filters?.status && filters.status !== "Всички" ? { status: filters.status } : {}),
            ...(filters?.sections ? { sections: filters.sections } : {}),
        },
    });

    return response.data;
}

export async function fetchSalesAnalyticsSupplements(period?: string, filters?: SalesAnalyticsQueryParams) {
    const response = await apiClient.get<SalesAnalyticsSupplementsResponse>("/reports/sales-analytics/supplements", {
        params: {
            ...(period && period !== "Персонализиран" ? { period } : {}),
            ...(filters?.dateFrom ? { date_from: filters.dateFrom } : {}),
            ...(filters?.dateTo ? { date_to: filters.dateTo } : {}),
            ...(filters?.channel && filters.channel !== "Всички" ? { channel: filters.channel } : {}),
            ...(filters?.region && filters.region !== "Всички" ? { region: filters.region } : {}),
            ...(filters?.store && filters.store !== "Всички" ? { store: filters.store } : {}),
            ...(filters?.client?.trim() ? { client: filters.client.trim() } : {}),
            ...(filters?.product?.trim() ? { product: filters.product.trim() } : {}),
            ...(filters?.status && filters.status !== "Всички" ? { status: filters.status } : {}),
        },
    });

    return response.data;
}

export async function fetchReportsDataset(period?: string) {
    const response = await apiClient.get<ReportsDatasetResponse>("/reports", {
        params: period ? { period } : undefined,
    });

    return response.data;
}

export async function fetchReportsChartsDataset(period?: string) {
    const response = await apiClient.get<ReportsChartsDatasetResponse>("/reports/charts", {
        params: period ? { period } : undefined,
    });

    return response.data;
}
